































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

@Component({
    name: 'sidebar',
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('bannerHomes', ['activeBannerHomeLoading', 'activeBannerHome', 'allBannerHomes', 'allBannerHomesLoading']),
    },
})
export default class Sidebar extends Vue {
    private currentUser!: any;
    public comment: string = '';
    public commentState: null;
    public comments: any = {};
    public showResponsiveDiv: boolean = true;
    public isMobile: boolean = false;
    activeBannerHomeLoading!: boolean;
    activeBannerHome!: any;
    allBannerHomes!: any;
    allBannerHomesLoading!: boolean;
    isButtonClicked !: boolean;
    view: string = '';
    view2: string = '';
    user2Id = '';

    canSee(roles: any) {
        let role_validation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; //montufar
        this.user2Id = '84bd1d1b-2e1c-45d5-8771-61872469a3e5'//Rodrigo -NO DEVELOPER
        let userId = '637ea688-0d66-4760-9292-3372582261c5'; //Developer

        // return _.intersection(roles, [this.currentUser.role.name]).length > 0;
        switch (this.currentUser.role.name) {
            case 'Admin':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                this.view = 'FeedbackPDV'
                break;
            case 'Developer':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                this.view = 'FeedbackPDV'
                break;
            case 'MercadoLibre Manager':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id == user1Id) {// && this.currentUser.id != userId) {
                    this.view = 'FeedbackPDV'
                }
                break;
            case 'Shop Manager':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id == this.user2Id) {
                    this.view2 = this.user2Id
                }
                break;
            case 'Iluminacion':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                this.view = 'FeedbackPDV'
                break;
            case 'Inventory':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Practicante':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Cajero':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break
            case 'gerente_pdv':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                this.view = 'FeedbackPDV'
                break
            case 'Surtido':
                role_validation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            default:
                role_validation = false;
                break;
        }
        return role_validation;
    }


    resetModal() {
        this.comment = '';
        this.commentState = null;
    }
    handleOk(bvModalEvent) {
        bvModalEvent.preventDefault();
        this.postComment();
    }

    onOpenBannerHomeModal() {
        this.isButtonClicked = true;
        this.$store.dispatch('bannerHomes/getLastOne');
        setTimeout(() => {
            this.$bvModal.show('banner-home-modal');
        }, 400);
    }

    postComment() {
        let userName = this.currentUser.first_name + ' ' + this.currentUser.last_name;

        if (this.comment) {
            this.comments = { text: this.comment, user: userName };
            setTimeout(() => {
                this.$bvModal.hide('modalForm');
            }, 2000);
        } else {
            this.$bvToast.toast('Por favor completa el campo', {
                title: `Datos insuficientes`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
    }

    onLogout() {
        //@ts-ignore
        this.$OneSignal.removeExternalUserId();
        this.$store.dispatch('auth/logout');
    }

    toggleResponsiveDiv() {
        this.showResponsiveDiv = !this.showResponsiveDiv;
    }
    checkMobile() {
        this.isMobile = window.innerWidth <= 768;
        if (!this.isMobile) {
            this.showResponsiveDiv = true;
        }
        return this.isMobile;
    }
    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    }

    // @Watch('currentUser')
    get userInfo() {
        // console.log(this.currentUser);
        //@ts-ignore
        this.$OneSignal.setExternalUserId(this.currentUser.id);
        return true;
    }

    // this.$OneSignal.on('subscriptionChange', function (isSubscribed: any) {
    //     console.log("The user's subscription state is now:", isSubscribed);
    //     // this.$OneSignal.setExternalUserId({ externalUserId: 'TEST'});
    // });
}
